import { useRef } from 'react';

import { BRIDGE_KEYS, LayerDataBridge } from '../../../../shared/utils/layer-data-bridge';
import { useLayerManager } from '../../../../shared/hooks/use-layer-manager';
import { useMyVwContext } from '../../../../shared/hooks/use-my-vw-context';
import { ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';

export type DiscardLayerData = {
  translationHandler: (key: string) => string;
  onDiscard: () => void;
  onKeepEditing: () => void;
};

type DiscardLayerRenderFn = (
  state: { dataBridge: LayerDataBridge<DiscardLayerData> },
  close: any,
) => JSX.Element;

export const useDiscardLayer = (
  renderFn: DiscardLayerRenderFn,
): { openDiscardLayer: (closeFn: () => void) => void } => {
  const layerManager = useLayerManager();
  const discardHandleRef = useRef<{ close: () => void } | null>(null);
  const bridge = LayerDataBridge.getInstance<DiscardLayerData>(BRIDGE_KEYS.DISCARD);
  const { translationHandler } = useMyVwContext();

  const openDiscardLayer = (closeFn: () => void) => {
    bridge.setData({
      translationHandler,
      onDiscard: () => { discardHandleRef.current?.close(); closeFn(); },
      onKeepEditing: () => discardHandleRef.current?.close(),
    });
    discardHandleRef.current = layerManager?.openFocusLayer(
      renderFn,
      { dataBridge: bridge },
      { size: 'A' as any, shimBackgroundType: ShimBackgroundTypeV2.OPAQUE },
    ) ?? null;
  };

  return { openDiscardLayer };
};
